/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Spaces_HintInputs */



/**
* | output |
* | --- |
* | "Pick what it may read and use. When it runs on its own, it works with exactly that; in a project chat, your picks are added to what the project already links..." |
*
* @param {Agent_Wizard_Spaces_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_spaces_hint = /** @type {((inputs?: Agent_Wizard_Spaces_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Spaces_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie, was er lesen und nutzen darf. Wenn er selbstständig läuft, arbeitet er genau damit; in einem Projekt-Chat kommt Ihre Auswahl zu dem hinzu, was das Projekt bereits verknüpft. Wer ihn ausführt, braucht Zugriff auf alles, was Sie auswählen. Ohne ausgewählten Bereich oder Datensatz nutzt er dasselbe Wissen wie Sie, auch wenn Verbindungen ausgewählt sind.")
	return /** @type {LocalizedString} */ ("Pick what it may read and use. When it runs on its own, it works with exactly that; in a project chat, your picks are added to what the project already links. Everyone who runs it needs access to each pick. Without a space or dataset picked, it uses the same knowledge you would, also when connections are picked.")
});